
<div class="fixed top-4 right-4 bg-red-600 text-white p-2 rounded-lg cursor-pointer" (click)="viewWishlist()">
    <!-- Wishlist ({{ wishlist.length }}) -->
     Wishlist
  </div>
  